// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './app'
import router from './router'
import store from './store'
import VueCookie from 'vue-cookie'
import wysiwyg from 'vue-wysiwyg'
import './filters'
import './config'
import 'normalize.css/normalize.css'
import 'vue-wysiwyg/dist/vueWysiwyg.css'

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(wysiwyg, {})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js